import api from "../api/axiosInstance";

// Fetch all subscription plans
export const getSubscriptionPlans = async () => {
  try {
    const response = await api.get("/subscription/plan/all");
    return response.data?.data || [];
  } catch (error) {
    console.error("Error fetching subscription plans:", error);
    throw error;
  }
};